import * as types from "../types";
import { ActionsCreators } from "../../actions";
import { requestAuth } from "../../helpers/FetchApi";
import appSettings from "../../AppSettings";
import { history } from "../../src/history";
import * as signalR from "@microsoft/signalr";

export const actionCreators = {
    GetOrganization: (org, callback) => async (dispatch, store) => {

        //change default user organization
        if (store().currentuser.user.userSettings) {
            const userData = JSON.parse(store().currentuser.user.userSettings);
            if (!userData.defaultOrganizationId || userData.defaultOrganizationId !== org.id) {
                userData.defaultOrganizationId = org.id;
                dispatch(ActionsCreators.EditCurrentUserSettings(userData));
                dispatch(ActionsCreators.closeAllMenus());
            }
        }
        else {
            dispatch(ActionsCreators.EditCurrentUserSettings({
                defaultOrganizationId: org.id
            }));
        }

        const orgUser = store().currentuser.user.organizationUsers.find((el) => {return el.organizationId === org.id;});

        //Get userName for this organization
        org.displayName = orgUser.displayName;

        //Get portalAgent for this organization
        let pa = orgUser.portalAgent;

        if (pa === undefined || pa === null) {pa = null;}
        else if (!pa.lockedByPilot) {
            pa.lockedByPilot = orgUser.id;
        }
        org.linkedPortalAgent = pa;

        console.log("getUserPortalAgent", pa);

        //set organization data
        dispatch({ type: types.GET_ORGANIZATION_COMPLETED, assets: org });
        dispatch({ type: types.GET_LINKEDPORTALAGENT_COMPLETED, payload: pa });

        //get dictionaries
        dispatch(ActionsCreators.GetContentTypesList());
        dispatch(ActionsCreators.GetDisplayTypesList());
        dispatch(ActionsCreators.GetTimezonesList());

        //Get current user UserGroup for organizationID
        await requestAuth(appSettings.SKALINKAPIURL + "/api/UserGroups/CurrentUserGroups/" + org.id, {
            method: "GET"
        }).then((data) => {
            dispatch({ type: types.GET_CURRENTUSER_USERGROUPS_COMPLETED, assets: data });

            const permissions = [];

            if (data && data.length > 0) {
                data.forEach(usergroup => {
                    usergroup.userGroupPermissions.forEach(perm => {
                        const index = permissions.findIndex(p => p.permissionTypeId === perm.permissionTypeId);
                        if (index >= 0) {
                            permissions[index].allow = Math.max(permissions[index].allow, perm.allow );
                            permissions[index].consult = Math.max(permissions[index].consult, perm.consult );
                            permissions[index].create = Math.max(permissions[index].create, perm.create );
                            permissions[index].delete = Math.max(permissions[index].delete, perm.delete );
                            permissions[index].modify = Math.max(permissions[index].modify, perm.modify );
                        }
                        else {
                            permissions.push({
                                permissionTypeId: perm.permissionTypeId,
                                allow: perm.allow,
                                consult: perm.consult,
                                create: perm.create,
                                delete: perm.delete,
                                modify: perm.modify
                            });
                        }
                    });
                });
            }

            const orgParameters = org.organizationParameters;
            const AllowVideoMessages = orgParameters.find(op => op.key.includes("AllowVideoMessages"));
            const AllowRemoteControl = orgParameters.find(op => op.key.includes("AllowRemoteControl"));
            const AllowRemotePayment = orgParameters.find(op => op.key.includes("AllowRemotePayment"));

            //get user Access rights
            const accessRights = {
                orgLimitations: {
                    allowVideoMessages: AllowVideoMessages && AllowVideoMessages.value.toString() === "True",
                    allowRemoteControl: AllowRemoteControl && AllowRemoteControl.value.toString() === "True",
                    allowRemotePayment: AllowRemotePayment && AllowRemotePayment.value.toString() === "True"
                },
                permissions: permissions,
                hasPermission: function(permissionTypeId, access) {
                    // if (store().currentuser.user.isSystemAdministrator) {
                    //     return 30;
                    // }
                    const permission = this.permissions.find(p => p.permissionTypeId === permissionTypeId);
                    if (!permission) {
                        return 0;
                    }
                    else {
                        return permission[access];
                    }
                }
            };

            //set user Access rights
            dispatch({ type: types.GET_CURRENTUSER_ACCESSRIGHTS_COMPLETED, assets: accessRights });

            dispatch(ActionsCreators.GetNavMenuBadges(org.id, accessRights));
            dispatch(ActionsCreators.GetNavBadgeVideoMessage(org.id, accessRights));
            dispatch(ActionsCreators.StartSignalR(org.id, orgUser.id, orgUser ));

            //Callback so we can redirect
            if (callback) {
                callback(true);
            }
            else {
                //Redirect to Dashboard
                setTimeout(() => {
                    // dispatch(push("/dashboard"));
                    history.push("/dashboard");

                }, 185);
            }
        }).catch( (data) => console.log(data));

        //Get used space for organization
        dispatch(ActionsCreators.GetContentSize());
    },

    GetNavMenuBadges: (organizationId, accesRights) => async (dispatch, store) => {
        //Nombre d'écrans déconnectés (ou au statut Unknown)
        dispatch(ActionsCreators.GetDisplaysDisconnectedCount(organizationId));

        //Nombre d'invitations en attente
        if (accesRights.CanManageAllUsers) {
            await requestAuth(
                appSettings.SKALINKAPIURL + "/api/Invitations/Count/" + organizationId,
                {
                    method: "GET"
                }).then((data) => {
                dispatch({ type: types.GET_INVITATIONSCOUNT_COMPLETED, payload: data });
            });
        }
    },

    GetNavBadgeVideoMessage: (organizationId, accessRights) => async (dispatch, store) => {
        // Number video message not been seen in organization
        if (accessRights.orgLimitations.allowVideoMessages) {
            await requestAuth(
                appSettings.SKALINKAPIURL + "/api/VideoMessage/Count/" + organizationId,
                {
                    method: "GET"
                }).then((data) => {
                dispatch({ type: types.GET_VIDEOMESSAGESNOTBEENSEENCOUNT_COMPLETED, payload: data });
            });
        }
    },

    GetDisplaysDisconnectedCount: (organizationId) => async (dispatch, store) => {
        await requestAuth(
            appSettings.SKALINKAPIURL + "/api/Displays/DisconnectedCount/" + organizationId,
            {
                method: "GET"
            }).then((data) => {
            dispatch({ type: types.GET_DISPLAYSDISCONNECTEDCOUNT_COMPLETED, payload: data });
        });
    },

    StartSignalR: (organizationId, userId, orgUser) => (dispatch, store) => {

        const WEBRTCConnectionURL = appSettings.WEBRTCConnectionURL;

        if (store().communication.webRTConnection && store().communication.webRTConnection.state !== signalR.HubConnectionState.Disconnected) {
            store().communication.webRTConnection.stop()
                .then(() => {
                    const dateLogs = new Date().toISOString();
                    console.log(`[${dateLogs}]`, "[signalR] - WEBRTCSignalR Connection stopped");
                });
        }

        const WebRTConnection = new signalR.HubConnectionBuilder()
            // .configureLogging(1)
            .withUrl(WEBRTCConnectionURL + "/WebRTC")
            .withAutomaticReconnect({
                nextRetryDelayInMilliseconds: () => 5000
            })
            .build();

        // SignalR reconnecting
        WebRTConnection.onreconnected(() => {
            const dateLogs = new Date().toISOString();
            console.log(`[${dateLogs}]`, "[signalR] - Reconnected to SignalR Hub");
            window.location.reload(true);
        });

        // Reload if signalR failed
        WebRTConnection.onclose((error) => {
            const dateLogs = new Date().toISOString();
            console.error(`[${dateLogs}]`, "[signalR] - The WebSocket connection failed: ", error);
            window.location.reload(true);
        });

        /// Linked Portal Agent Session
        WebRTConnection.on("OnPortalLinkToPilotChanged", async (isLinked, idPortalAgent) => {
            const dateLogs = new Date().toISOString();
            console.log(`[${dateLogs}]`, "[signalR] - ==> OnPortalLinkToPilotChanged isLinked", isLinked, idPortalAgent);
            if (isLinked) {
                let linkedPortalAgent = {};
                await requestAuth(appSettings.SKALINKAPIURL + "/api/Messaging/GetPortalAgent/" + idPortalAgent, {
                    method: "GET"
                }).then((data) => {
                    linkedPortalAgent = data;
                    linkedPortalAgent.isLinked = isLinked;
                    linkedPortalAgent.lockedByPilot = data ? data.id : null;
                }).catch( (data) => {
                    console.log("ERROR GetPortalAgent", data);
                    linkedPortalAgent.lockedByPilot = null;
                }).finally(() => {
                    dispatch({ type: types.GET_LINKEDPORTALAGENT_COMPLETED, payload: linkedPortalAgent });
                });
            }
            else {
                const linkedPortalAgent = store().communication.linkedPortalAgent;
                if (linkedPortalAgent) {
                    linkedPortalAgent.isLinked = isLinked;
                    linkedPortalAgent.lockedByPilot = null;
                    dispatch({ type: types.GET_LINKEDPORTALAGENT_COMPLETED, payload: linkedPortalAgent });
                }

            }
        });

        WebRTConnection.on("OnUserConnectionChanged", (id, connectionStatus) => {
            const dateLogs = new Date().toISOString();
            console.log(`[${dateLogs}]`, "[signalR] - OnUserConnectionChanged", "user -- " + id + " , status -- " + connectionStatus);

            const usersList = store().administration.users;
            if (usersList && usersList.results) {
                const us = usersList.find(u => u.id === id);
                if (us && us.connectionStatus !== connectionStatus) {
                    us.connectionStatus = connectionStatus;
                    return dispatch({ type: types.GET_USERS_COMPLETED, payload: { ...usersList } });
                }
            }
        });

        WebRTConnection.on("OnVideoMessageCollectionChanged", (orgId) => {
            const dateLogs = new Date().toISOString();
            console.log(`[${dateLogs}]`, "[signalR] - OnVideoMessageCollectionChanged", "orgId -- " + orgId);
            if (store().currentuser.currentorganization.id === orgId && store().home.currentMenuName === "Messaging") {
                const list = store().contents.videomessages;
                if (list && list.results) {
                    dispatch(ActionsCreators.GetVideoMessagesList(
                        list.currentPage,
                        list.pageSize,
                        list.sortExpression,
                        list.filterExpression,
                        list.tagSearchRequest,
                        list.PaginationType,
                        () => {}, null,
                        list.zoneId,
                        list.callCenterId,
                        list.startDate,
                        list.endDate )
                    );
                }
            }
            if (store().currentuser.currentorganization.id === orgId) {
                const accessRights = store().currentuser.accessrights;
                dispatch(ActionsCreators.GetNavBadgeVideoMessage(orgId, accessRights));
            }
        });

        /// Portal status updated
        WebRTConnection.on("OnPortalStatusChanged", (uniqueIdentifier, status, portalVersion, webAppVersion ) => {
            const dateLogs = new Date().toISOString();
            console.log(`[${dateLogs}]`, "[signalR] - OnPortalStatusChanged", uniqueIdentifier + "--" + status + "--" + portalVersion + "(" + webAppVersion + ")");

            let isAgent = false;

            //update current linked agent
            const linkedPortalAgent = store().communication.linkedPortalAgent;
            if (linkedPortalAgent && linkedPortalAgent.uniqueIdentifier === uniqueIdentifier && linkedPortalAgent.portalStatusId.toString() !== status.toString()) {
                console.log(`[${dateLogs}]`, "[pilot] - updateLinkedPortalAgentStatus", "linkedPortalAgent -- " + status);
                isAgent = true;
                linkedPortalAgent.portalStatusId = status;
                dispatch({ type: types.GET_LINKEDPORTALAGENT_COMPLETED, payload: linkedPortalAgent });
            }

            //update portalAgentsList
            const paList = store().monitoring.portalagents;
            if (paList && paList.results) {
                const pa = paList.results.find(p => p.uniqueIdentifier === uniqueIdentifier);
                if (pa && pa.portalStatusId && pa.portalStatusId.toString() !== status.toString()) {
                    console.log(`[${dateLogs}]`, "[pilot] - updatePortalAgentStatus", pa.name + "--" + status);
                    isAgent = true;
                    pa.portalStatusId = status;
                    if (portalVersion) {pa.applicationVersion = portalVersion;}
                    if (webAppVersion) {pa.webAppVersion = webAppVersion;}
                    return dispatch({ type: types.GET_PORTALAGENTS_COMPLETED, payload: { ...paList } });
                }
            }

            if (!isAgent) {
                //update portalClientsList
                const pcList = store().monitoring.displays;
                if (pcList && pcList.results) {
                    const pc = pcList.results.find(p => p.uniqueIdentifier === uniqueIdentifier);
                    if (pc && pc.portalStatusId && pc.portalStatusId.toString() !== status.toString()) {
                        console.log(`[${dateLogs}]`, "[pilot] - updatePortalClientStatus", pc.name + "--" + status);
                        pc.portalStatusId = status;
                        if (portalVersion) {pc.applicationVersion = portalVersion;}
                        if (webAppVersion) {pc.webAppVersion = webAppVersion;}
                        return dispatch({ type: types.GET_DISPLAYS_COMPLETED, payload: { ...pcList } });
                    }
                }
            }
            else {
                return;
            }

        });

        /// Portal agent modeSleep updated
        WebRTConnection.on("OnPortalSleepModeChanged", (uniqueIdentifier, sleepMode) => {
            const dateLogs = new Date().toISOString();
            console.log(`[${dateLogs}]`, "[signalR] - OnPortalSleepModeChanged", uniqueIdentifier + "--" + sleepMode);

            //for now, if sleepMode == 0 (normal) et sleepMode == 1 (break), on utilise le meme status
            const isModeSleep = sleepMode;

            //update current linked agent
            const linkedPortalAgent = store().communication.linkedPortalAgent;
            if (linkedPortalAgent && linkedPortalAgent.uniqueIdentifier === uniqueIdentifier) {
                linkedPortalAgent.modeSleep = isModeSleep;
                dispatch({ type: types.GET_LINKEDPORTALAGENT_COMPLETED, payload: linkedPortalAgent });
            }

            //update portalAgentsList
            const paList = { ...store().monitoring.portalagents };
            if (paList && paList.results) {
                const pa = paList.results.find(p => p.uniqueIdentifier === uniqueIdentifier);
                if (pa && pa.modeSleep.toString() !== sleepMode.toString()) {
                    pa.modeSleep = Number(sleepMode);
                    return dispatch({ type: types.GET_PORTALAGENTS_COMPLETED, payload: paList });
                }
            }

            // updatedisplaysList
            const displaysList = { ...store().monitoring.displays };
            if (displaysList && displaysList.results) {
                const display = displaysList.results.find(p => p.uniqueIdentifier === uniqueIdentifier);
                if (display && display.modeSleep.toString() !== sleepMode.toString()) {
                    display.modeSleep = Number(sleepMode);
                    return dispatch({ type: types.GET_DISPLAYS_COMPLETED, payload: { ...displaysList } });
                }
            }
        });

        WebRTConnection.on("OnCallAppClientsChanged", (idOrganisation) => {
            const dateLogs = new Date().toISOString();
            console.log(`[${dateLogs}]`, "[signalR] - OnCallAppClientsChanged", idOrganisation);
            if (idOrganisation === store().currentuser.currentorganization.id) {
                dispatch(ActionsCreators.GetCallApps(WebRTConnection));
            }
        });

        /// Call Session Gestion

        //OnSessionStarting IdRoom:  5202f12b-5858-44de-b608-1e579afc8e3c IdPortalAgent:  2 IdPortalClient : 8
        WebRTConnection.on("OnSessionStarting", async (IdRoom, uIdPortalAgent, uIdPortalClient) => {
            const session = {
                status: "starting",
                IdRoom: IdRoom,
                IdPortalAgent: uIdPortalAgent,
                IdPortalClient: uIdPortalClient,
                PortalAgentName: store().communication.linkedPortalAgent.name,
                PortalClientName: "",
                webCallGuid: webCallGuid,
                Categories: [],
                CallStartingTime: new Date().toISOString()
            };
            const dateLogs = new Date().toISOString();
            console.log(`[${dateLogs}]`, "[signalR] - ==> OnSessionStarting", session);

            if ( uIdPortalClient.includes("anonymous") && !webCallGuid) {return;}

            const detailedInfoURL = uIdPortalClient.includes("anonymous") ?
                appSettings.SKALINKAPIURL + "/api/FreeCall/GetDetailedCallLinkInfo/" + webCallGuid :
                appSettings.SKALINKAPIURL + "/api/FreeCall/GetDetailedDisplayInfo/" + btoa(uIdPortalClient);

            await requestAuth(detailedInfoURL, {
                method: "GET"
            }).then((data) => {
                session.PortalClientName = data.name;
                session.PortalClientZone = data.zoneName;
                session.Categories = data.categories;
                dispatch({ type: types.GET_CALLSESSION_COMPLETED, payload: session });
                // dispatch(push("/callLink"));
                this.props.ChangeCurrentMenuName("callLink");
                history.push("/callLink");
            }).catch( (data) => {
                console.log(data);
            });
        });

        //OnSessionStarted IdRoom:  5202f12b-5858-44de-b608-1e579afc8e3c IdPortalAgent:  2 IdPortalClient : 8
        WebRTConnection.on("OnSessionStarted", async (IdRoom, uIdPortalAgent, uIdPortalClient, startTime, sharedResources, webCallGuid) => {
            const dateLogs = new Date().toISOString();
            console.log(`[${dateLogs}]`, "[signalR] - ==> OnSessionStarted");

            let session = store().communication.callSession;
            if (!session) {
                session = {
                    status: "running",
                    IdRoom: IdRoom,
                    IdPortalAgent: uIdPortalAgent,
                    IdPortalClient: uIdPortalClient,
                    SharedResources: sharedResources,
                    PortalAgentName: store().communication.linkedPortalAgent ? store().communication.linkedPortalAgent.name : "",
                    PortalClientName: "",
                    webCallGuid: webCallGuid,
                    CallStartingTime: startTime
                };

                if ( uIdPortalClient.includes("anonymous") && !webCallGuid) {return;}

                const detailedInfoURL = uIdPortalClient.includes("anonymous") ?
                    appSettings.SKALINKAPIURL + "/api/FreeCall/GetDetailedCallLinkInfo/" + webCallGuid :
                    appSettings.SKALINKAPIURL + "/api/FreeCall/GetDetailedDisplayInfo/" + btoa(uIdPortalClient);

                await requestAuth(detailedInfoURL, {
                    method: "GET"
                }).then((data) => {
                    session.PortalClientName = data.name;
                    session.PortalClientZone = data.zoneName;
                    session.Categories = data.categories;
                    dispatch({ type: types.GET_CALLSESSION_COMPLETED, payload: session });
                    // dispatch(push("/callLink"));
                    history.push("/callLink");
                }).catch( (data) => {
                    console.log(data);
                });
            }
            else {
                session.status = "running";
                session.CallStartedTime = startTime;
                session.webCallGuid = webCallGuid;
                dispatch({ type: types.GET_CALLSESSION_COMPLETED, payload: session });
                // dispatch(push("/callLink"));
                history.push("/callLink");
            }
        });
        WebRTConnection.on("OnSharedResourcesChanged", (key, property, value) => {
            const dateLogs = new Date().toISOString();
            console.log(`[${dateLogs}]`, "[signalR] - ===> OnSharedResourcesChanged", "key: ", key, " property: ", property, " value:", value);
            const session = store().communication.callSession;
            if (session && session.SharedResources) {
                const sr = JSON.parse(session.SharedResources);
                sr[key][property] = value;
                dispatch({ type: types.GET_CALLSESSION_COMPLETED, payload: { ...session, SharedResources: JSON.stringify(sr) } });
            }
        });

        //OnSessionEnded
        WebRTConnection.on("OnSessionEnded", () => {
            const dateLogs = new Date().toISOString();
            console.log(`[${dateLogs}]`, "[signalR] - ==> OnSessionEnded");
            dispatch({ type: types.GET_CALLSESSION_COMPLETED, payload: null });
        });
        WebRTConnection.on("OnSessionCancelled", () => {
            const dateLogs = new Date().toISOString();
            console.log(`[${dateLogs}]`, "[signalR] - ==> OnSessionCancelled");
            dispatch({ type: types.GET_CALLSESSION_COMPLETED, payload: null });
        });
        WebRTConnection
            .start()
            .then(async () => {
                const dateLogs = new Date().toISOString();
                console.log(`[${dateLogs}]`, "[signalR] - SignalR WEBRTC Connection started");
                dispatch({ type: types.GET_WEBRTCONNECTION_COMPLETED, payload: WebRTConnection });
                WebRTConnection.invoke("Connect", userId.toString(), "SkaPilot", false, null);
                setTimeout( dispatch(ActionsCreators.GetCallApps(WebRTConnection)), 500);
                const idOrganisation = store().currentuser.currentorganization.id;
                await requestAuth(appSettings.SKALINKAPIURL + "/api/FreeCall/AllOrganizationFreeCallLinks/" + idOrganisation, {
                    method: "GET"
                }).then((fcldata) => {
                    dispatch({ type: types.GET_FREECALLLINK_SECONDARY_COMPLETED, payload: { results: fcldata } });
                });
            })
            .catch(err => {
                const dateLogs = new Date().toISOString();
                console.log(`[${dateLogs}]`, "[signalR] - Error while establishing connection", err);
            });
    },
    GetCallApps: (WebRTConnection) => (dispatch, store) => {
        const idOrganisation = store().currentuser.currentorganization.id;
        if (WebRTConnection) {
            const dateLogs = new Date().toISOString();
            console.log(`[${dateLogs}]`, "[signalR] - Invoke => GetCallAppClients", idOrganisation);
            WebRTConnection.invoke("GetCallAppClients", idOrganisation).then((data) => {
                console.log("GetCallAppClients", data);
                return dispatch({ type: types.GET_FREECALLAPP_COMPLETED, payload: data });
            });
        }
    },
    EditCallSessionResources: (newResources) => (dispatch, store) => {
        const session = store().communication.callSession;
        session.SharedResources = newResources;
        dispatch({ type: types.GET_CALLSESSION_COMPLETED, payload: session });
    },
    EditPaginationListType: (listname, newPaginationType) => (dispatch, store) => {
        switch (listname) {
            case "waitinglist" :
                dispatch({ type: types.GET_PAGINATIONTYPE_WAITINGLIST_COMPLETED, payload: newPaginationType });
                break;
            case "webcall" :
                dispatch({ type: types.GET_PAGINATIONTYPE_WEBCALL_COMPLETED, payload: newPaginationType });
                break;
            case "calllogs" :
                dispatch({ type: types.GET_PAGINATIONTYPE_CALLOG_COMPLETED, payload: newPaginationType });
                break;
        }
    },
    EditCallLogData: (sessionId, callLogData, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Reporting/CallLogInformations/" + store().currentuser.currentorganization.id
        + "?&sessionId=" + sessionId, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(callLogData),
            method: "PUT"
        }).then((data) => {
            return onSuccess(data);
        }).catch( (data) => {
            console.log("error", data);
        });

    },

    GetCurrentUser: (callback) => async (dispatch, store) => {

        //FOR NOW
        //the only language allowed for now is french (SNCF Link)
        if (localStorage.getItem("lang") !== "fr") {
            localStorage.setItem("lang", "fr");
            //window.location.reload();
        }

        //Get current user datas
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Users/Current", { method: "GET" }).then((data) => {

            const user = data;
            if (!user.organizationUsers) {user.organizationUsers = [];}
            if (user.id !== 0 && user.organizationUsers && user.organizationUsers.some(ou => ou.connectionStatus)) {
                console.log("User already connected");
                user.connectionStatus = true;
            }
            //set user data
            dispatch({ type: types.GET_CURRENTUSER_COMPLETED, assets: user });

            if (!user.connectionStatus && user.id !== 0 ) {

                //if the user has only one active organisation
                if (user.organizationUsers
                    && user.organizationUsers.length === 1
                    && !user.organizationUsers[0].isDisabled
                    && !user.organizationUsers[0].organization.isDisabled) {
                    const myOrg = user.organizationUsers[0].organization;
                    myOrg.isOrganizationAdministrator = user.organizationUsers[0].isOrganizationAdministrator;
                    return dispatch(ActionsCreators.GetOrganization(myOrg, callback));
                }

                //if the user has no active organisation and only one invitation
                /*else if (user.invitations && user.invitations.length === 1) {
                    return dispatch(ActionsCreators.AcceptInvitation(user.invitations[0]));
                }*/

                //if the user has multiple organisations
                else if (user.organizationUsers && user.organizationUsers.length > 1) {
                    //if there is an organisation in the user settings
                    if (user.userSettings) {
                        const userData = JSON.parse(user.userSettings);
                        if (userData.defaultOrganizationId) {
                            const ou = user.organizationUsers.find((org) => { return org.organizationId === userData.defaultOrganizationId;});
                            if (ou && ou !== undefined && !ou.isDisabled && !ou.organization.isDisabled) {
                                const myOrg = ou.organization;
                                myOrg.isOrganizationAdministrator = ou.isOrganizationAdministrator;
                                return dispatch(ActionsCreators.GetOrganization(myOrg, callback));
                            }
                        }
                    }
                }
                return callback();
            }
            else {
                callback();
            }

        }).catch( (data) => { console.log(data); callback();});
    },

    AcceptInvitation: (invitation) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Invitations/AcceptInvitation/" + invitation.id, {
            method: "GET"
        }).then((data) => {
            //set local state
            localStorage.setItem("defaultOrganization" + data, invitation.organizationId);

            dispatch(ActionsCreators.GetCurrentUser());

        }).catch( (data) => {
            console.log(data);
        });
    },

    EditCurrentUserSettings: (newSettings) => async (dispatch, store) => {

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Users/Settings", {
            headers: {
                "Content-Type": "application/json"
            },
            body: "'" + JSON.stringify(newSettings) + "'",
            method: "POST"
        }).then((data) => {
            dispatch({ type: types.SET_CURRENTUSER_NEWSETTINGS, assets: newSettings });
        }).catch( (data) => console.log(data));
    },

    SendPaymentConsent: (informationConsent) => (store) => {
        return fetch(
            appSettings.SKALINKAPIURL + "/api/Consents",
            {
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(informationConsent),
                method: "POST"
            }
        ).then(response => {
            if (response.ok) {
                console.log("Consent information sent successfully:", response);
                return true;
            }
            else {
                console.error("Failed to send consent information, status code:", response ? response.status : "No response");
                return false;
            }
        }).catch((error) => {
            console.error("Error sending consent information:", error);
            return false;
        });
    }

};
